import BasicRepository, {AllArgs, ListArgs} from "./basicRepository";
import Client from "../client";
import {TenantMissingVariableResource, TenantVariableResource, TenantResource, TagTestResult} from "../resources";
import { uploadLogo } from "./logoUpload";
import { isAllowed } from "components/PermissionCheck/PermissionCheck";
import { Permission } from "client/resources/permission";

interface TenantListArgs extends ListArgs {
    projectId?: string;
}

interface TenantAllArgs extends AllArgs {
    projectId?: string;
}

class TenantRepository extends BasicRepository<TenantResource, TenantResource, TenantListArgs, TenantAllArgs> {
    constructor(client: Client) {
        super("Tenants", client);
    }

    tagTest(tenantIds: string[], tags: string[]): Promise<TagTestResult> {
        return this.client.get(this.client.getRootDocument().Links["TenantTagTest"],
            {tenantIds, tags});
    }

    getVariables(tenant: TenantResource): Promise<TenantVariableResource> {
        return this.client.get(tenant.Links["Variables"]);
    }

    setVariables(tenant: TenantResource, variables: any): Promise<TenantVariableResource> {
        return this.client.put(tenant.Links["Variables"], variables);
    }

    missingVariables(filterOptions: FilterOptions = {}, includeDetails: boolean = false): Promise<TenantMissingVariableResource[]> {
        const payload = {
            environmentId: filterOptions.environmentId,
            includeDetails: !!includeDetails,
            projectId: filterOptions.projectId,
            tenantId: filterOptions.tenantId
        };
        return this.client.get(this.client.getRootDocument().Links["TenantsMissingVariables"], payload);
    }

    uploadLogo(tenant: TenantResource, logo: File) {
        return uploadLogo(tenant, logo);
    }

    all(args?: TenantAllArgs): Promise<TenantResource[]> {
        if (!isAllowed({ permission: Permission.TenantView, tenant: "*" })) {
            return Promise.resolve([]);
        }
        return super.all(args);
    }
}

type FilterOptions = {
    tenantId?: string;
    projectId?: string;
    environmentId?: string;
};

export default TenantRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/tenantRepository.ts